import styles from './Footer.module.css';

function Footer() {
  return (
    <>
      <div className={styles.footer}></div>
    </>
  );
}

export default Footer;
